import { useLayoutEffect, useRef } from 'react';
import company from '../../../assets/images/icons/company.svg';
import employeeIcon from '../../../assets/images/icons/employee.svg';
import OpacityAnimation from '../../../components/OpacityAnimation';
import floatToCurrency from '../../../utils/floatToCurrency';
import { CoordType, DataByWorkplaceType } from '../types';

interface DisplayEmployeesMapInterface {
  data: DataByWorkplaceType[];
}

export default function DisplayEmployeesMap({ data }: DisplayEmployeesMapInterface) {
  const mapRef = useRef(null);

  useLayoutEffect(() => {
    const locTrab = data.map((i) => (
      { lat: i.locTrab.lat, lng: i.locTrab.lng, name: i.locTrab.name }
    ));
    const employees = data.map((i) => (
      {
        lat: i.lat,
        lng: i.lng,
        name: i.name,
        cpf: `•••.•••.${i.cpf?.slice(8, 16)}`,
        matricula: i.matricula,
        currentVt: i.currentVT,
        minVt: i.minVT ?? i.currentVT,
      }
    ));
    if (!mapRef.current) return undefined;
    const ltCoords = { lat: locTrab[0].lat, lng: locTrab[0].lng };
    const { H } = window;
    const platform = new H.service.Platform({
      apikey: process.env.REACT_APP_HERE_KEY,
    });
    const defaultLayers = platform.createDefaultLayers();
    // Create an instance of the map
    const mapInstance = new H.Map(
      mapRef.current,
      defaultLayers.vector.normal.map,
      {
        center: ltCoords,
        zoom: 12,
        pixelRatio: window.devicePixelRatio || 1,
      },
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(mapInstance));
    const ui = H.ui.UI.createDefault(mapInstance, defaultLayers);

    function addMarkersToMap(map: any) {
      const ltIcon = new H.map.Icon(company);
      // const ltName = locTrab[0].name;
      const ltMarker = new H.map.Marker(ltCoords, { icon: ltIcon });
      map.addObject(ltMarker);

      employees.forEach((employee) => {
        const employeeIc = new H.map.Icon(employeeIcon);
        const employeeCoord = { lat: employee.lat, lng: employee.lng };
        const employeeName = employee.name;
        const employeeMarker = new H.map.Marker(employeeCoord, { icon: employeeIc });

        function addMarkerToGroup(group: any, coordinate: CoordType, html: string) {
          const marker = new H.map.Marker(coordinate, { icon: employeeIc });
          // add custom data to the marker
          marker.setData(html);
          group.addObject(marker);
        }

        function addInfoBubble(mp: any) {
          const group = new H.map.Group();
          mp.addObject(group);

          // add 'tap' event listener, that opens info bubble, to the group
          group.addEventListener('tap', (evt: any) => {
            // event target is the marker itself, group is a parent event target
            // for all objects that it contains
            const bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
              // read custom data
              content: evt.target.getData(),
            });
              // show info bubble
            ui.addBubble(bubble);
          }, false);

          addMarkerToGroup(
            group,
            employeeCoord,
            `<div style="
                min-inline-size: max-content;
            ">
              ${employeeName}
              <br>
              CPF: ${employee.cpf}
              <br>
              Matricula: ${employee.matricula ?? 'Não especificado'}
              <br>
              VT Atual: ${floatToCurrency((employee.currentVt))}
              <br>
              VT Indicado: ${floatToCurrency((employee.minVt))}
              <br>
              VT Atual: ${floatToCurrency((employee.currentVt))}
              <br>
              VT Indicado: ${floatToCurrency((employee.minVt))}
              <br>
              Economia: ${floatToCurrency(employee.currentVt - Number(employee.minVt))}
            </div>`,
          );
        }
        map.addObject(employeeMarker);
        addInfoBubble(map);
      });
    }

    addMarkersToMap(mapInstance);

    return () => {
      mapInstance.dispose();
    };
  }, [data, mapRef]);

  return (
    <OpacityAnimation delay={0.5}>
      <div ref={mapRef} style={{ height: '500px', width: '100%' }} />
    </OpacityAnimation>
  );
}
